import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteLocalidade,
  findLocalidade,
  recordFiltering,
} from '~/store/modules/localidade/actions';

import localidadeForm from './form';

function LocalidadeList() {
  const redux = useSelector((state) => state.localidade);

  const status = [
    { label: 'L', value: t('s.geral.opcoes.liberado') },
    { label: 'B', value: t('s.geral.opcoes.bloqueado') },
    { label: 'C', value: t('s.geral.opcoes.cancelado') },
  ];

  const header = useMemo(
    () => [
      {
        id: 'idlocalidade',
        label: t('s.cadastro.motorista.idmotorista'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nomelocalidade',
        label: t('s.cadastro.motorista.nomemotorista'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'statuslocalidade',
        label: t('s.cadastro.motorista.statusmotorista'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    []
  );

  const fieldlist = ['idlocalidade', 'nomelocalidade', 'statuslocalidade'];

  const substituirHeader = {
    idlocalidade: t('s.cadastro.motorista.idmotorista'),
    nomelocalidade: t('s.cadastro.motorista.nomemotorista'),
    statuslocalidade: t('s.cadastro.motorista.statusmotorista'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findLocalidade}
      remove={deleteLocalidade}
      form={localidadeForm}
      keys="idlocalidade"
      detach="idlocalidade"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'localidades',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Localidades',
          substituirValores: {
            statuslocalidade: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
          },
        })
      }
    />
  );
}

export default LocalidadeList;

/**
s.cadastro.motorista.idcliente
s.cadastro.motorista.idmotorista
s.cadastro.motorista.nomemotorista
s.cadastro.motorista.senhamotorista
s.cadastro.motorista.statusmotorista
*/
